import { FileQuestionMark, Lock } from 'lucide-react';
import { Link } from 'react-router-dom';

import { EmptyState, Nut } from '../../../ui/index.js';

export function KhongDuQuyenPage() {
  return (
    <div className="rounded-the border border-vien bg-be-mat">
      <EmptyState
        icon={Lock}
        loi
        title="Không đủ quyền"
        description="Tài khoản của bạn không được xem phần này. Liên hệ quản trị viên nếu cần quyền truy cập."
        action={
          <Link to="/">
            <Nut kieu="phu">Về trang chủ</Nut>
          </Link>
        }
      />
    </div>
  );
}

export function KhongTimThayPage() {
  return (
    <div className="rounded-the border border-vien bg-be-mat">
      <EmptyState
        icon={FileQuestionMark}
        title="Không tìm thấy trang"
        description="Đường dẫn không tồn tại hoặc module tương ứng chưa được cài."
        action={
          <Link to="/">
            <Nut kieu="phu">Về trang chủ</Nut>
          </Link>
        }
      />
    </div>
  );
}
